import { useCallback, useEffect, useMemo, useState } from "react";
export function useFilterButtonsState({ filters, onFilterChanged }) {
    const [selectedFilter, setSelectedFilter] = useState(filters?.[0]);
    const handleFilterClicked = useCallback((identifier) => () => {
        const filter = filters?.find((filter) => filter.identifier === identifier);
        setSelectedFilter(filter);
    }, []);
    useEffect(() => {
        if (!!selectedFilter) {
            onFilterChanged(selectedFilter);
        }
    }, [selectedFilter]);
    return useMemo(() => ({
        handleFilterClicked,
        selectedFilter,
    }), [handleFilterClicked, selectedFilter]);
}
